var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"miyi-frame"},[_c('iframe',{staticStyle:{"position":"relative","top":"-84px","height":"calc(100% + 88px)"},attrs:{"src":_vm.src,"width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }